import { addServerIp } from '../api/serverIpSlice';

export const captureServerIp = (result, api, headerName = 'X-App-Node') => {
  try {
    const ip = result?.meta?.response?.headers?.get(headerName);
    if (ip) {
      api.dispatch(addServerIp(ip));
    }
  } catch { /* empty */ }
};
